import DiscoWaveOrb from '../../DiscoWaveOrb';
import RotatingDeck from '../../RotatingDeck';
import {
  formatPartyMoodOrderLabel,
  getPartyMoodById,
} from '../../../utils/partyMoods';
import { legacyPartyMoodIds } from '../../../vibe/legacy';

/** Legacy Party Mood orb. Not used for vibe-schema parties. */
export default function LegacyPartyMood({ eventData, isPlaying }) {
  const selectedMoods = legacyPartyMoodIds(eventData)
    .map((id) => getPartyMoodById(id))
    .filter(Boolean);
  const moodColors = selectedMoods.length
    ? selectedMoods.map((mood) => mood.color)
    : undefined;

  return (
    <div className="mx-auto flex w-full max-w-[350px] flex-col items-center">
      <div className="relative flex aspect-square w-full flex-col items-center justify-center overflow-hidden">
        <RotatingDeck playing={isPlaying} size={280} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <DiscoWaveOrb
            isPlaying={isPlaying}
            colors={moodColors}
            color={moodColors?.[0]}
          />
        </div>
      </div>
      <div className="-mt-2 flex flex-wrap items-center justify-center gap-1.5 px-2">
        {selectedMoods.length === 0 ? (
          <span className="text-sm text-white/70">Party mood</span>
        ) : selectedMoods.map((mood, index) => (
          <span
            key={mood.id}
            className={`rounded-full border text-white ${
              selectedMoods.length === 1
                ? 'px-3 py-1 text-sm font-medium'
                : 'px-2 py-0.5 text-[11px]'
            }`}
            style={{
              borderColor: selectedMoods.length === 1 ? mood.color : `${mood.color}99`,
              backgroundColor: selectedMoods.length === 1 ? `${mood.color}2E` : `${mood.color}18`,
            }}
          >
            {formatPartyMoodOrderLabel(mood, index, selectedMoods.length)}
          </span>
        ))}
      </div>
    </div>
  );
}
